import { lumiApi } from "../index";
import { Doc } from "../../../utils/Docs/Docs";

export const projectsApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getSentiments: build.mutation({
            query: ({ id, concept_selector, filter = null, match_type }) => {
                const body = filter
                    ? {
                          concept_selector,
                          filter,
                          match_type,
                          include_examples: true,
                      }
                    : { concept_selector, match_type, include_examples: true };

                return {
                    url: `/projects/${id}/concepts/sentiment`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),
        getSentimentsBreakdown: build.mutation({
            query: ({
                id,
                concept_selector,
                filter = null,
                match_type,
                breakdowns = [],
                include_examples,
            }) => {
                const body = {
                    concept_selector,
                    match_type,
                    breakdowns,
                    filter,
                    include_examples,
                };

                return {
                    url: `/projects/${id}/concepts/sentiment_breakdown`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),
        getSentimentsDocs: build.mutation({
            query: ({
                        id,
                        concept_selector,
                        filter ,
                        search,
                        include_examples = true,
                    }) => ({
                url: `/projects/${id}/concepts/sentiment_json/`,
                method: "POST",
                body: {
                    concept_selector,
                    filter,
                    search: { texts: [...search] },
                    include_examples,
                },
            }),
            transformResponse: (response) =>{
                return response?.docs
                    .filter((doc) => doc.title?.trim() || doc.text.trim())
                    .map(Doc.fromJSON);
            }
        }),
    }),
});

export const { useGetSentimentsMutation, useGetSentimentsBreakdownMutation, useGetSentimentsDocsMutation } =
    projectsApi;
